import { EVALUATION_TYPES } from "./../constants/storageConstants";
import { STEPS } from "./../constants/stepsConstants";
import Navbar from "./Navbar";
import LifeCycleCostLogo from "./images/logo/LifeCycleCostLogo.png";
import CapXLogo from "./images/logo/capxLogo.png";
import PropTypes from "prop-types";

/**
 *
 * @param {string} [activeStep] step of the flow we are on. can be undefined if the user is on a page that is not part of the flow like disclaimer, about, or contact
 * @param {string} currentEvaluationType
 * @returns
 */
export default function ICEToolNavBar({ currentEvaluationType, activeStep }) {
  const showIcon =
    activeStep &&
    activeStep !== STEPS.HOMEPAGE &&
    activeStep !== STEPS.PROJECT_INFORMATION &&
    !!currentEvaluationType;

  const lifeCycleCostLogo = {
    src: LifeCycleCostLogo,
    alt: "Life Cycle",
  };

  const capXLogo = {
    src: CapXLogo,
    alt: "CAP-X",
  };

  const logo =
    currentEvaluationType === EVALUATION_TYPES.LIFE_CYCLE_COST
      ? lifeCycleCostLogo
      : capXLogo;

  return (
    <Navbar
      icon={
        showIcon && (
          <img
            src={logo.src}
            alt={logo.alt}
            style={{ height: "50px", margin: "5px" }}
          />
        )
      }
    ></Navbar>
  );
}

ICEToolNavBar.propTypes = {
  currentEvaluationType: PropTypes.string,
  activeStep: PropTypes.string,
};
